import { Page } from '@optools/components/layout/page';
import { authorizedRouteLoader } from '@optools/utils/auth/authorized-route-loader';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/milestones')({
  beforeLoad: authorizedRouteLoader('milestones'),
  component: RouteComponent,
});

function RouteComponent() {
  return <Page title="Milestones" />;
}
